export default {
  name: "verify-in-table",
  components: {},
  props: [],
  data() {
    return {};
  },
  computed: {
    routeCategory() {
      return this.$route.query.category === "cryptoCurrency"
        ? "crypto"
        : this.$route.query.category === "IRR"
        ? "rial"
        : "";
    }
  },
  mounted() {},
  methods: {}
};
